module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Address-card-9cf9eecb4692c4826d5a5669366256b8.svg";